<template>
  <div>
    <v-btn icon style="float:left" @click.native.stop="searchBegin">
      <v-icon>search</v-icon>
    </v-btn>
    <div :class="{'searching--closed': !searching}" class="searching">
      <v-text-field id="searchGroup" v-model="formValue" autocomplete="off" append-icon="close" placeholder="Filter..." hide-details single-line @click:append="searchEnd" />
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      value: String,
    },

    data: () => ({
      searching: false,
    }),

    computed: {
      formValue: {
        get() {
          return this.value;
        },
        set(value) {
          this.$emit('input', value);
        },
      },
    },

    methods: {
      onFocus() {
        this.formValue = '';
      },

      searchBegin() {
        this.searching = true;
        setTimeout(() => document.querySelector('#searchGroup').focus(), 50);
      },

      searchEnd() {
        this.searching = false;
        this.formValue = '';
        document.querySelector('#searchGroup').blur();
      },
    },
  };
  </script>

<style>
  .searching .v-text-field {
    padding-top: 10px;
    margin-right: 10px;
  }

  .searching .v-text-field > .v-input__control > .v-input__slot:before {
    border-width: thin 0 1px 0;
  }

  .searching--closed {
    padding-left: 0;
    width: 0 !important;
  }

  .searching > * {
    right: 8px;
  }

  .searching > .input-group {
  margin-top: 6px;
  }

  .searching--closed > * {
    display: none;
  }
</style>